import * as types from '../actions/types'


const pagesReducer = (state = {}, action) => {
    switch(action.type) {
        case types.FETCH_PAGES_SUCCESS:
            return { ...state, pages: action.pages};
        default:
            return state;
    }
};

export default pagesReducer;


// WEBPACK FOOTER //
// ./src/reducers/pagesReducer.js